export enum RoleType {
  CREDIT_AUTHORITY = 'IPPCreditAuthority',
  ACCOUNT_MANAGER = 'IPPAccountManager',
  ADMIN = 'IPPAdmin',
}
